<form [formGroup]="formGroup" class="dialog-container">
  <div class="dialog-header">
    <h4>{{ "summary.addReport" | translate }}</h4>
    <button class="icon-close-large" type="button" (click)="dialogRef.close()"></button>
  </div>
  <div class="container">
    <div class="section-container">
      <div class="flex-row">
        <div class="flex-2 card-cell">
          <sag-ui-input formControlName="title" [required]="true" [label]="'template.item.title' | translate" />
        </div>
        <div class="flex-1 card-cell">
          <sag-ui-select formControlName="responsibleType" [required]="true" [label]="'responsible.item.responsibleType' | translate">
            <sag-ui-option value="sag">{{ "responsible.item.sagUnit" | translate }}</sag-ui-option>
            <sag-ui-option value="rc">{{ "responsible.item.corporateCountry" | translate }}</sag-ui-option>
          </sag-ui-select>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 card-cell">
          <sag-ui-textarea formControlName="description" [required]="true" [label]="'hyperlink.item.description' | translate" />
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 card-cell">
          <app-drop-zone accept=".pdf" formControlName="documents" [required]="true" />
        </div>
      </div>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <sag-ui-button type="button" color="secondary" (click)="dialogRef.close()">{{ "generic.buttons.cancel" | translate }}</sag-ui-button>
      <sag-ui-button type="button" color="primary" [disabled]="isSaving" (click)="createSummaryReport()">
        {{ "generic.buttons.save" | translate }}
      </sag-ui-button>
    </div>
  </div>
</form>
